<template>
    <app-wrapper>
        <app-header medium-max-width="max-w-1000" medium-max-width-inner="max-w-500">
            <template #navigation>
                <div class="w-full max-w-500 mx-auto flex items-center justify-between mb-6">
                    <h5 class="font-zen-dots text-white">
                        <AppLogo />
                    </h5>
                </div>
            </template>
        </app-header>
        <app-body :collapsed="true" medium-max-width="max-w-500" footer>

            <template #title>
                Manage Email Preferences
            </template>

            <template #text>
                <div v-if="!isUnsubscribed">
                    Are you sure you want to stop receiving these emails?
                </div>
                <div v-else>
                    You've been unsubscribed from this email campaign.
                </div>
            </template>

            <template #main>
                <div class="text-center mt-5">
                    <button
                        v-if="!isUnsubscribed"
                        @click="unsubscribe"
                        :disabled="loading || buttonDisabled"
                        class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
                    >
                        {{ loading ? 'Processing...' : buttonDisabled ? `Unsubscribe (${countdown}s)` : 'Unsubscribe' }}
                    </button>
                    <button
                        v-else
                        @click="subscribe"
                        :disabled="loading || buttonDisabled"
                        class="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
                    >
                        {{ loading ? 'Processing...' : buttonDisabled ? `Subscribe (${countdown}s)` : 'Subscribe' }}
                    </button>
                </div>
            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import AppLogo from './../components/AppLogo';

export default {
    components: {
        AppLogo
    },
    props: {
        csrf: {},
        item: {},
        type: {},
        signature: {},
        unsubscribed: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            isUnsubscribed: this.unsubscribed,
            buttonDisabled: false,
            countdown: 3,
            countdownInterval: null
        }
    },

    methods: {
        unsubscribe() {
            this.loading = true;

            this.$http.post('/account/profile/unsubscribe', {
                item: this.item,
                type: this.type,
                signature: this.signature,
                _token: this.csrf
            }).then(() => {
                this.isUnsubscribed = true;
                this.loading = false;
                this.startCountdown();
            }).catch(error => {
                console.log(error.data);
                this.loading = false;
            });
        },

        subscribe() {
            this.loading = true;

            this.$http.post('/account/profile/subscribe', {
                item: this.item,
                signature: this.signature,
                type: this.type,
                _token: this.csrf
            }).then(() => {
                this.isUnsubscribed = false;
                this.loading = false;
                this.startCountdown();
            }).catch(error => {
                console.log(error.data);
                this.loading = false;
            });
        },

        startCountdown() {
            this.buttonDisabled = true;
            this.countdown = 3;
            this.countdownInterval = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    this.clearCountdown();
                }
            }, 1000);
        },

        clearCountdown() {
            this.buttonDisabled = false;
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
                this.countdownInterval = null;
            }
        }
    },

    beforeUnmount() {
        this.clearCountdown();
    }
}
</script>
